import React from 'react';
import PropTypes from 'prop-types';
import {
  Badge,
  Cushion,
  FlexContainer,
  Grid,
  Image,
  Rectangle,
  Typography,
} from '@pitchero/react-ui';
import { DateTime } from 'luxon';
import { connect } from 'react-redux';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import { getCurrentClub } from '../../store/clubs/selectors';

const PreviewFixture = ({ club, fixture, isLast }) => {
  const renderScore = (score) =>
    score ? (
      <FlexContainer
        justifyContent="center"
        alignItems="center"
        style={{
          padding: '5px 8px',
          backgroundColor: 'black',
          color: 'white',
          borderRadius: '5px',
          fontWeight: 'bold',
        }}
      >
        {score}
      </FlexContainer>
    ) : (
      <div />
    );

  const renderLogo = (homeOrAway, primary, secondary) => (
    <FlexContainer justifyContent="center" alignItems="center" style={{ marginRight: '10px' }}>
      {fixture.homeOrAway === homeOrAway ? (
        <Image src={club.logo} alt={club.name} width={40} height={40} loading="lazy" />
      ) : (
        <Badge primary={primary} secondary={secondary} size={40} />
      )}
    </FlexContainer>
  );

  return (
    <Rectangle borderTop={isLast ? 'none' : '1px solid #d9d9d9'} key={fixture.id}>
      <Cushion
        all="medium"
        responsive={[{ maxWidth: 600, props: { all: 'small' } }]}
        component="div"
      >
        <FlexContainer flexDirection="column" style={{ gap: '10px' }}>
          <FlexContainer justifyContent="space-between">
            <Typography size={14} color="dustygrey">
              {DateTime.fromISO(fixture.date).toFormat('ccc d LLL y')}
            </Typography>
            {fixture.kickoff && (
              <Typography size={14} color="dustygrey">
                KO:&nbsp;
                {fixture.kickoff}
              </Typography>
            )}
          </FlexContainer>
          <Grid columns="auto 1fr auto" rows="1fr 1fr" rowGap="10px" alignItems="center">
            {fixture.homePrimary ? (
              renderLogo('h', fixture.homePrimary, fixture.homeSecondary)
            ) : (
              <div />
            )}
            <Typography size={16} preset="title">
              {fixture.homeTeamName}
            </Typography>
            {renderScore(fixture.homeScore)}
            {fixture.awayPrimary ? (
              renderLogo('a', fixture.homePrimary, fixture.homeSecondary)
            ) : (
              <div />
            )}
            <Typography size={16} preset="title">
              {fixture.awayTeamName}
            </Typography>
            {renderScore(fixture.awayScore)}
          </Grid>
        </FlexContainer>
      </Cushion>
    </Rectangle>
  );
};

PreviewFixture.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  fixture: PropTypes.shape({
    id: PropTypes.string,
    date: PropTypes.string,
    kickoff: PropTypes.string,
    homeTeamName: PropTypes.string,
    homeScore: PropTypes.string,
    homePrimary: PropTypes.string,
    homeSecondary: PropTypes.string,
    awayTeamName: PropTypes.string,
    awayScore: PropTypes.string,
    awayPrimary: PropTypes.string,
    awaySecondary: PropTypes.string,
    homeOrAway: PropTypes.oneOf(['h', 'a']),
  }).isRequired,
  isLast: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  club: getCurrentClub(state),
});

export default connect(mapStateToProps)(PreviewFixture);
